<template>
  <div class="shadow rounded-1">
    <h2 class="p-3 mb-0">Peta Sebaran Data dan Informasi Pelaksanaan KKPRL</h2>
    <p class="px-3 text-secondary">{{ periodLabel }}</p>
    <div class="position-relative">
      <l-map
        ref="map"
        style="height: 80vh; background: transparent"
        :zoom="zoom"
        :center="center"
        :options="mapOptions"
        @ready="onMapReady"
      >
        <l-geo-json v-if="geojson" :geojson="geojson" :options="geoJsonOptions" />
      </l-map>
      <div class="map-detail">
        <template v-if="activeFeature">
          <h5 class="fw-semibold">{{ activeFeature.PROVINSI }}</h5>
          <table>
            <tbody>
              <tr v-for="metric in metrics" :key="metric.key">
                <td>{{ metric.label }}</td>
                <td class="ps-2">: {{ formatNumber(activeSummary[metric.key]) }}</td>
              </tr>
            </tbody>
          </table>
        </template>
        <p v-else class="mb-0">Klik provinsi untuk melihat data penilaian pelaksanaan.</p>
      </div>
    </div>
  </div>
</template>

<script>
import { LMap, LGeoJson } from 'vue2-leaflet'
import L from 'leaflet'
import 'leaflet-easybutton'
import 'leaflet-easybutton/src/easy-button.css'
import provinsi from '../Pengendalian/provinsi.json'
import { emptyPelaksanaanSummary } from './dummyPelaksanaan'

export default {
  components: { LMap, LGeoJson },
  props: {
    summaryByProvince: { type: Object, required: true },
    periodLabel: { type: String, required: true },
  },
  data() {
    return {
      geojson: provinsi,
      zoom: 5,
      center: [-1.897, 118.5303],
      mapOptions: { zoomControl: true, scrollWheelZoom: false },
      activeFeature: null,
      activeLayer: null,
      mapInstance: null,
      defaultStyle: { weight: 1, color: '#3388ff', fillColor: '#3388ff', fillOpacity: 0.4 },
      activeStyle: { weight: 2, color: '#008a00', fillColor: '#66cc66', fillOpacity: 0.7 },
      hoverStyle: { weight: 2, color: '#d99a00', fillColor: '#ffe680', fillOpacity: 0.7 },
      metrics: [
        { key: 'penilaianPelaksanaan', label: 'Penilaian Pelaksanaan' },
        { key: 'taat', label: 'Jumlah Taat' },
        { key: 'taatDenganCatatan', label: 'Taat dengan Catatan' },
        { key: 'tidakTaat', label: 'Tidak Taat' },
      ],
    }
  },
  computed: {
    activeSummary() {
      if (!this.activeFeature) return emptyPelaksanaanSummary()
      return this.summaryByProvince[String(this.activeFeature.id)] || emptyPelaksanaanSummary()
    },
    geoJsonOptions() {
      return {
        style: (feature) => (
          this.activeFeature && String(this.activeFeature.id) === String(feature.properties.id)
            ? this.activeStyle
            : this.defaultStyle
        ),
        onEachFeature: (feature, layer) => {
          layer.on({
            click: () => this.selectFeature(feature, layer),
            mouseover: () => {
              if (this.activeFeature && String(this.activeFeature.id) === String(feature.properties.id)) return
              layer.setStyle(this.hoverStyle)
            },
            mouseout: () => {
              if (this.activeFeature && String(this.activeFeature.id) === String(feature.properties.id)) return
              layer.setStyle(this.defaultStyle)
            },
          })
        },
      }
    },
  },
  methods: {
    selectFeature(feature, layer) {
      if (this.activeLayer && this.activeLayer !== layer) this.activeLayer.setStyle(this.defaultStyle)
      this.activeFeature = feature.properties
      this.activeLayer = layer
      layer.setStyle(this.activeStyle)
    },
    resetSelection() {
      if (this.activeLayer) this.activeLayer.setStyle(this.defaultStyle)
      this.activeLayer = null
      this.activeFeature = null
    },
    resetView() {
      if (this.mapInstance) this.mapInstance.setView(this.center, this.zoom)
    },
    formatNumber(value) {
      return Number(value || 0).toLocaleString('id-ID')
    },
    onMapReady(map) {
      this.mapInstance = map
      L.easyButton('fa-refresh', () => this.resetSelection()).addTo(map)
      L.easyButton('fa-window-maximize', () => this.resetView()).addTo(map)
      this.$nextTick(() => map.invalidateSize())
    },
  },
  watch: {
    summaryByProvince() {
      if (this.activeLayer) this.activeLayer.setStyle(this.activeStyle)
    },
  },
  beforeDestroy() {
    this.mapInstance = null
    this.activeLayer = null
  },
}
</script>

<style scoped>
.map-detail {
  position: absolute;
  z-index: 1000;
  top: 10px;
  right: 10px;
  max-width: 340px;
  padding: 12px;
  border: 1px solid #ccc;
  border-radius: 5px;
  background: rgba(255, 255, 255, 0.95);
}

@media (max-width: 575.98px) {
  .map-detail {
    position: static;
    max-width: none;
    margin: 10px;
    background: #fff;
  }
}
</style>
